const AboutUs = () => {
  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden w-full">
      <div className="container mx-auto flex flex-col md:flex-row">
        <div className="flex-grow p-8 order-last md:order-first">
          <h2 className="text-2xl font-semibold mb-4">
            About Our Anime Community
          </h2>
          <p className="text-lg leading-relaxed mb-4">
            Welcome to our vibrant anime community dedicated to all fans of
            Japanese animation! We are passionate about sharing our love for
            anime and creating a welcoming space where enthusiasts can come
            together to discuss their favorite shows, characters, and more.
          </p>
          <p className="text-lg leading-relaxed mb-4">
            Our community is built on the principles of inclusivity, creativity,
            and mutual respect. Whether you're a seasoned otaku or just
            discovering the world of anime, there's a place for you here. Join
            us in exploring the rich tapestry of anime genres, from
            action-packed shonen to heartwarming slice-of-life.
          </p>
          <p className="text-lg leading-relaxed mb-4">
            As a member of our community, you'll have access to exclusive
            events, discussions, and resources designed to enhance your anime
            experience. Dive into the world of cosplay, attend virtual
            screenings, and connect with fellow fans from around the globe.
          </p>
          <a
            href="/#/about"
            className="bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            More Info
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
